<template>
  <div
    class="card card-custom bgi-no-repeat card-stretch gutter-b"
    :class="bodyClass"
    :dir="dir !== 'ltr' ? 'rtl' : 'ltr'"
    style="background-position: left top; background-size: 30% auto"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
  >
    <div class="card-body">
      <span v-if="svg">
        <inline-svg :src="svg"></inline-svg>
      </span>
      <span
        class="card-title font-weight-bolder font-size-h2 mb-0 mt-3 d-block"
        :class="titleClass"
      >
        {{ title }}
      </span>

      <span class="font-weight-bold font-size-sm" :class="subtitleClass">
        {{ subtitle }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "count-info",
  props: {
    dir: String,
    bodyClass: String,
    titleClass: String,
    subtitleClass: String,
    title: String,
    subtitle: String,
    svg: String,
    background: String
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    backgroundImage() {
      return process.env.BASE_URL + this.background;
    }
  }
};
</script>
